import moment from 'moment';
import { i18n } from 'core/i18n';
const { formatText } = i18n;

import DateHelper from 'utilities/dateHelper';

import { CARD_DETAILS_TEMPLATE, MOTIVE_SELECT_OPTIONS, MOTIVE_SELECT_OPTIONS_MAPPING } from "../constants";

const getMotiveCardDetailValue = (immAccountCancel) => {
    const motiveSelect = immAccountCancel.get('motiveSelect');
    let value = 'Por definir';
    if (motiveSelect) {
        value = formatText(MOTIVE_SELECT_OPTIONS_MAPPING[motiveSelect]);
    }
    return value;
}

export const getCardDetails = (immAccount, immAccountCancel, immProfile) => {
    const todayDate = DateHelper.todayDate();
    const todayDay = DateHelper.getDay(todayDate);
    const todayMonth = moment().month(DateHelper.getMonth(todayDate) - 1).locale(immProfile.get('mainLanguage')).format('MMM')
    const todayYear = DateHelper.getFullYear(todayDate);
    return CARD_DETAILS_TEMPLATE.map(detail => {
        if (detail.id === 'alias') {
            return { ...detail, value: immAccount.get('alias') };
        }
        if (detail.id === 'iban') {
            return { ...detail, value: immAccount.get('iban') };
        }
        if (detail.id === 'type') {
            return { ...detail, value: immAccount.get('descProducto').trim() };
        }
        if (detail.id === 'motive') {
            return {
                ...detail,
                value: getMotiveCardDetailValue(immAccountCancel),
            };
        }
        if (detail.id === 'applicationDate') {
            return {
                ...detail,
                value: 'contractsView-renewalDateValue',
                isLanguageString: true,
                injectedStringValues: [todayDay, todayMonth, todayYear],
            };
        }
        return detail;
    });
};

export const getMotiveSelectOptions = () => {
    return MOTIVE_SELECT_OPTIONS.map(option => (
        {
            ...option,
            label: formatText(option.label),
        }
    ));
}

export const getBreadcrumb = (immAccount) => {
    return [
        {
            text: formatText('accounts-accounts'),
            url: '/myprofile/accounts'
        },
        {
            text: immAccount.get('alias'),
            url: `/myprofile/accounts/${immAccount.get('accountId')}/movements`
        },
        {
            text: formatText("cancellation_account-cancellation_account_entrypoint"),
            url: ''
        }
    ]
};
